// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"5":"1f771e03","220":"981b1687","293":"99e7ed93","314":"842d4da2","337":"da9fded4","413":"88a86682","554":"79854d44","746":"21e961b9"}[chunkId] + ".js";
};